import { useUserStore, useProfileStore } from '../stores'
import { consumeProfileRun } from './profileRunPending'

/**
 * PROD-1192 (L2a): the patient's first main-app screen consumes the "health-profile run pending"
 * marker. Called at the first mount of any MobileLayout route (before useIdleTimeout reads its
 * stamp) and by the OnboardingFlow reload-to-/home resume. If the marker is pending for this user,
 * the away/idle clocks restart once; the marker is removed in every case.
 */
export function consumeProfileRunAtFirstHome() {
  const u = useUserStore.getState()
  return consumeProfileRun({
    userId: u.user?.id,
    profile: useProfileStore.getState().profile,
    now: Date.now(),
    onPending: () => useUserStore.getState().clearAwayForSetupEnd(),
  })
}
